import Chieh from '../static/images/sectionTalking/2021/Chieh.jpg';
import Dennis from '../static/images/sectionTalking/2021/Dennis.jpg';
import Malik from '../static/images/sectionTalking/2021/Malik.jpg';
import Flex from '../static/images/sectionTalking/2021/Flex.jpg';
import Lily from '../static/images/sectionTalking/2021/Lily.jpg';
import Roger from '../static/images/sectionTalking/2021/Roger.jpg';
import YouHua from '../static/images/sectionTalking/2021/Youhua.jpg';
import Marco from '../static/images/sectionTalking/2021/Marco.jpg';
import Adam from '../static/images/sectionTalking/2021/Adam.jpg';
import Susan from '../static/images/sectionTalking/2021/Susan.jpg';
import Jimmy from '../static/images/sectionTalking/2021/Jimmy.jpg';
import Bonnie from '../static/images/sectionTalking/2021/Bonnie.jpg';
import Cecilia from '../static/images/sectionTalking/2021/Cecilia.jpg';
import Jennie from '../static/images/sectionTalking/2021/Jennie.jpg';
import Miley from '../static/images/sectionTalking/2021/Miley.jpg';
import ChingYa from '../static/images/sectionTalking/2021/ChingYa.jpg';

import ChiehPhoto from '../static/images/sectionTalking/2021/ChiehPhoto.png';
import DennisPhoto from '../static/images/sectionTalking/2021/DennisPhoto.png';
import MalikPhoto from '../static/images/sectionTalking/2021/MalikPhoto.png';
import FlexPhoto from '../static/images/sectionTalking/2021/FlexPhoto.png';
import LilyPhoto from '../static/images/sectionTalking/2021/LilyPhoto.png';
import RogerPhoto from '../static/images/sectionTalking/2021/RogerPhoto.png';
import YouHuaPhoto from '../static/images/sectionTalking/2021/YouhuaPhoto.png';
import MarcoPhoto from '../static/images/sectionTalking/2021/MarcoPhoto.png';
import AdamPhoto  from '../static/images/sectionTalking/2021/AdamPhoto.png';
import SusanPhoto  from '../static/images/sectionTalking/2021/SusanPhoto.png';
import JimmyPhoto from '../static/images/sectionTalking/2021/JimmyPhoto.png';
import BonniePhoto from '../static/images/sectionTalking/2021/BonniePhoto.png';
import CeciliaPhoto  from '../static/images/sectionTalking/2021/CeciliaPhoto.png';
import JenniePhoto from '../static/images/sectionTalking/2021/JenniePhoto.png';
import MileyPhoto  from '../static/images/sectionTalking/2021/MileyPhoto.png';
import ChingYaPhoto from '../static/images/sectionTalking/2021/ChingYaPhoto.png';

export default [
    {
        name: "CHIEH",
        position: "Front-End Developer",
        img: ChiehPhoto,
        photo: Chieh,
        article: `
            <p>​​安安，我是 Front-End Intern 劉杰</p>

            <p>大家點進來這個網頁大概都想進來當實習生吧？</p>

            <p>那我先講怎麼脫穎而出，讓 你/妳 有面試的機會吧</p>

            <p>1. 展現出你是個有趣並且有料的人吧！不管是興趣廣泛、人生閱歷豐富都行</p>

            <p>2. 講出你有多想加入新芽，以及你對前端的熱情</p>

            <p>3. 其他的作品集、履歷表你應該都懂的</p>

            <p>本身已經工作一陣子（非在校、非剛畢業、非相關領域），因為對工程師的憧憬（錢景、工作型態），而自學踏入相關領域，想進一步了解業界以及有 Mentor 帶領，因此加入新芽。主要工作是協助所屬專案工程師分配的工作，整個流程以及工作方式都必須符合內部文件規範（我相信這就是大家要的啦！）</p>
            
            <p>1. 完整的 Git Flow 工作流程</p>

            <p>2. 參閱 Figma/ Zeplin</p>

            <p>3. 依據需求製作 component / 頁面</p>

            <p>4. 根據 Issue 內容跟 PM/ UI/ Backend 來回溝通</p>

            <p>5. Mentor 給予指點</p>

            <p>如果上述內容符合你的需求，那就趕快投遞履歷加入吧！</p>

            <p>啊對了還有零食跟飲料、咖啡，真的是無限補充（倉庫是 MOMO 購物網），你吃完了就有人在後面補（是真的有人在補）！</p>
        `,
    },
    {
        name: "DENNIS",
        position: "Front-End Developer",
        img: DennisPhoto,
        photo: Dennis,
        article: `
            <p>​​Hello, 我是新芽 SurveyCake Front-End Developer Intern 的實習生 Dennis</p>

            <p>對於一個常常在關注新創產業的人，一定多少都會在 Medium/Facebook 看到 SurveyCake 這個有名且多人使用的產品，而很幸運就在 4 月時看到了實習生的招募計畫，身為一個熱愛實習的人，這間是一定要投的！</p>

            <p>這不是我的第一份實習，卻是目前待過最棒的地方。</p>

            <p>曾經在小到只有幾個人的工作室、大到營業額幾百億的外商公司，新芽有的新創文化，在其他地方是完全無法體驗到的</p>

            <p>剛進 SurveyCake 實習時，我很幸運的由三個很照顧實習生，能力也非常強的 Mentor 帶領。</p>

            <p>團隊感覺不出有任何高低，一切都是走一個扁平的討論文化，也鼓勵提出想法，一起激盪。他們指導了我許多在 Frontend 開發上的技術，Code Review 不但詳細也給與鼓勵與回饋，透過一年的實習，讓我的前端能力有大幅提升，了解 clean code 以及完善的 Git flow 。在這期間，我同時負責 SurveyCake 的 E2E testing，讓我從對測試完全不懂的我，到能完成整個大專案的自動化測試開發，真的會產生很大的成就感 。</p>

            <p>此外，公司也有社團可以參與，也時常準備 Workshop，當然也有一些很有趣的活動，這些都是促進大家感情與提升凝聚力。而公司也有非常多來自不同學校、科系的實習生，彼此實習生的感情也都很好，我們也會利用公司資源舉辦聚餐、活動，透過與大家討論聊天，交換不同的資訊，增廣見聞外也加深加廣自己的朋友圈，這些都是對於未來相當有幫助的！</p>
            
            <p>最後，如果你已經看到這篇了，請勇敢投遞履歷，並即將體會到絕佳的面試體驗XD</p>
        `,
    },
    {
        name: "MALIK",
        position: "Front-End Developer",
        img: MalikPhoto,
        photo: Malik,
        article: `
            <p>大家好，我是前端實習生 Malik。</p>

            <p>我大學是念資管系的，系上沒有任何一堂課在教我們寫前端，相關知識都是從網路上自學，這過程從大二開始大概「斷斷續續的」有一年的時間。直到大三時在思考未來方向時，還是喜歡前端開發帶給我及時回饋的感覺，因此集中精神在前端學習上，特別是 React。接觸 React 約四個月後我在大三下面試了這份工作，並從升大四暑假開始實習至今。</p>

            <p>在這裡工作不只是產出，可以從和 Mentor 討論如何實作某項功能時讓自己的能力有所提升，正職夥伴也不吝於討論，平常也都有時間可以學習新知，讓工作時間不是只有產出而已。此外在這邊寫的專案也跟過去自己做 Side Project 有很大的不同，不論是規模、複雜度、功能等等都大了好幾個等級，也因此光是程式碼就有許多可以參考跟學習的地方。當然，專案除了考驗技術能力，也需要和 PM 保持密切的溝通。</p>

            <p>前端團隊是一個很歡樂的部門，許多正職都會關心彼此的工作狀況，主管也是，Mentor 就更不用說了。實習生與 Mentor 每個月會有一次 1 on 1 的時間，在這裡可以暢所欲言，和 Mentor 聊聊實習生活，聊聊想學習的東西、學習到的東西，也可以大方提出有什麼可以改進之處。簡言之這裡有一個能讓大家一起變更強、更好的環境，而不會感覺自己是在單打獨鬥。</p>

            <p>如果看到這邊覺得這樣的生活跟收獲是你期望的，就勇敢給自己一個機會吧～</p>
        `,
    },
    {
        name: "FLEX",
        position: "Back-End Developer",
        img: FlexPhoto,
        photo: Flex,
        article: `
            <p>雖然因為疫情的關係公司改變了上班模式，一開始不太能夠習慣，但藉由 Mentor 的帶領下能夠快速熟悉現有開發軟體架構，學習專案開發上的團隊溝通，還有許多學校學不到的職場經驗。</p>

            <p>在新芽的實習期間能夠實際參與中大型專案開發，後端大大們也會熱心的討論程式要如何改進以及許多建議，解決開發專案上的問題，一步步的提升自我能力。</p>

            <p>很開心能夠進入新芽，期間留下了很多人生的第一次還有回憶，公司的文化和福利一定和能讓每個人都喜歡。</p>
        `,
    },
    {
        name: "LILY",
        position: "iOS Developer",
        img: LilyPhoto,
        photo: Lily,
        article: `
            <p>哈囉～～ 大家好我是 Lily，第一天 on board 的時候就被辦公室環境和佈置美哭，也很喜歡同事一起工作的氣氛，平時公司也會有活動和點心讓大家一起參與（不知不覺真的會吃太胖....  </p>

            <p>在進入實習之前，我只會簡單的 MVC 架構、用 StoryBoard 拉畫面、簡單的 API 串接。直到現在，我學會 Git 版本控制、使用 MVVM 架構、用 Code 的方式刻 UI ，也逐漸掌握較複雜的邏輯，回去看之前不懂的文章時，也發現漸漸能夠看的懂了（Wow 原來就是我專案實作過的那樣子，也實實在在的感受到自己的進步。</p>

            <p>我很感謝這段時間帶領我的 Mentor ，每個禮拜都會有 Brief，主要是 Code review，他會跟我說哪個地方怎麼寫會更好，也會分享一些他自己寫程式的看法，還有出一些小考題讓我練習，謝謝他讓我在實作中獲得成長，也謝謝 iOS 另外兩位人超好的大大，在我有問題時都會很有耐心的幫我解決，覺得能在 APP Team 裡面實習真的很幸福。</p>

            <p>最後想說，新芽真的是一個很棒的地方，公司福利就不用多說了吧，團隊的氣氛也是充滿熱血與熱情的地方，我很開心能夠來到新芽和大家一起成長，謝謝新芽帶給我的一切  </p>
        `,
    },
    {
        name: "ROGER",
        position: "Android Developer",
        img: RogerPhoto,
        photo: Roger,
        article: `
            <p>Hi 我是第八屆實習生 Roger</p>

            <p>時間過得好快，來到新芽已經半年多了，每天都能夠與音樂、零食、有趣的同事度過，我想說能在新芽擔任 Android 實習生真的是一件很幸福的事。</p>

            <p>很幸運在新芽有個很照顧我的 Mentor ，會幫我 Code Review ，指導我寫出更好的程式，隨時有問題找公司的同事或是 Mentor 他們都會很熱情的跟你討論，我們也會在每個禮拜的例會輪流技術分享，不僅可以持續學到新東西，也可以練習自己表達的能力。</p>

            <p>公司的氣氛也非常的棒，有來自不同地方不同學校有趣的人們，每天上班都很像在玩樂，會有人在公司做甜點，在沙發區討論，公司總是充滿歡笑，工作起來又能非常認真有效率！
            所以呢，如果你想磨練自己變得更強，想要能在歡樂的氣氛下工作，那新芽絕對是個很棒的地方！</p>
        `,
    },
    {
        name: "YOU-HUA",
        position: "Project Management",
        img: YouHuaPhoto,
        photo: YouHua,
        article: `
            <p>Hi 我是第八屆的 PM Intern Youhua</p>

            <p>很開心可以進入當初自己夢想的公司新芽擔任 PM Intern，無論是這邊的同事、辦公室環境我都很喜歡，這是一趟學習與反思很多、也很幸運的旅程。</p>

            <p>專案管理實習生的日常，會同時負責 2～3 個專案，需要協助正職的 PM 處理各種任務，並且從 0 到 1 的學習各種所需的零碎知識，雖然初期可能會覺得需要學習的 Loading 有點重，但正職 PM 與開發者們都會耐心的講解每個任務需要注意的事項，也可以額外多學很多功能背後的實作原理。</p>

            <p>在整趟實習過程中，會對專案開發的產品進行測試，並在遇到 Bug 時練習與開發者的溝通，逐漸熟悉在與開發者溝通時需要交付的資訊，同時也會學習產品 Issue 的撰寫，觀摩正職 PM 如何將客戶例會中的需求轉化成具體 Requirement，並且交付給團隊成員，在熟悉軟體產品的基本運作原理後，會深入學習相關知識，並學會 Postman、Swagger UI 等 API 文件管理與測試工具，可以進一步加強與開發者的溝通能力。</p>

            <p>對我來說，有以下幾點是在參與這份實習後，你可以獲得的：</p>

            <p>・ 對專案的開案、設計開發、測試上線流程有基本認識</p>

            <p>・ 對專案團隊如何進行 Issue 的管理有基本認識</p>

            <p>・ 對產品測試、文件撰寫的規則有基本認識</p>

            <p>最後，我想說非常幸運可以成為新芽的一份子，也在學生時期能擁有這些實作經驗與知識的學習，如果你對專案管理、網路科技有興趣，快來申請吧：）</p>
        `,
    },
    {
        name: "MARCO",
        position: "Project Management",
        img: MarcoPhoto,
        photo: Marco,
        article: `
            <p>嗨嗨大家好！我是新芽實習計畫第八屆的專案管理實習生 Marco，在新芽實習的這段期間真的幸褔到有剩，辦公室環境優美（每次拍照都被問說是不是在咖啡廳），飢餓或腦力耗竭時進食各種零食飲料補充精力，工作氣氛融洽，做事時搭配 DJ 播放的背景音樂，跟同事坐在窗邊的四角桌發生觸動生命的談話，上班時總是能有好心情去面對接踵而來的挑戰。在擔任專案管理實習生時，跟著正職一同與會面對客戶，學習應對進退跟臨機應變，討論專案的大小事，定期回顧工作表現，準備工作坊的分享，吸收軟體新知，跟其他實習生聊聊工事、聊聊未來。這些時刻都是無可取代的美好回憶跟經驗！</p>

            <p>大學時主修外文系，研究所唸翻譯，看起來跟軟體或專案管理八竿子打不著，但幸好當初沒有因為害怕而卻步，還是遞出了申請，好好準備了履歷跟面試，以小白（不是蠟筆小新的狗）的姿態幸運地開啟這趟實習之旅，一路上收穫滿到快溢出來，感受到了過往實習從未有過的體驗跟成長。如果你想要體驗自由的新創文化，實際參與軟體專案管理的流程，感受同事間的真誠交流，來新芽申請專案管理實習生，絕對是不會後悔的選擇！</p>
        `,
    },
    {
        name: "ADAM",
        position: "Project Management",
        img: AdamPhoto,
        photo: Adam,
        article: `
            <p>哈囉～大家好我是 PM Intern Adam～</p>

            <p>來到新芽也 10 個月了，很幸運的參與了不同類型的專案，不管是 B2B 或 B2C 的專案都從中學習到很多專案管理的技巧及思維。在多次與客戶開會的過程中，觀摩正職們與客戶的互動則讓我意識到從確立需求到開發完成有非常多的細節需要注意。能在這段時間了解並體會完整的開發流程讓我感到收穫滿滿！</p>

            <p>雖然大多都在疫情及遠距工作中度過，但也體現了公司裡工作環境的高度彈性及效率。因為疫情的關係，很可惜的錯過了許多活動，但仍能透過其他的方式去補足這樣得遺憾，能確實的感受到公司對團隊的重視。而自由開放的文化及環境，讓我們可以更自在地分享觀點，在教學相長的同時還能結交到許多很棒的朋友。</p>

            <p>很開心人生第一份實習是在新芽渡過的，多虧了新芽良好的工作環境，不管是工作能力或是軟體的相關知識都受益匪淺。推薦想在網路軟體相關產業或是專案管理有興趣的朋友加入並成為新芽的一份子，相信你會因此成為一棵大樹！</p>
        `,
    },
    {
        name: "SUSAN",
        position: "Account Management",
        img: SusanPhoto,
        photo: Susan,
        article: `
            <p>對一個文組小菜雞而言，網路產業的世界真的非常酷而且充滿挑戰，總是有源源不絕的新事物可以學習！</p>

            <p>AM 平時的工作主要是負責接洽專案客戶，協助他們規劃建置 APP 或是網站，進而找出痛點、提案幫助客戶成功。疫情趨緩後，甚至還會有不少能跟著 Mentor 一起業務拜訪、見識場面的機會！而新芽自由的新創氛圍，讓實習生與 Mentor 的溝通更加順暢、也有很多自主發揮的空間。</p>

            <p>更棒的是，能夠透過不同專案接觸到不一樣的產業、也能觀察到各個產業的數位轉型趨勢。對我來說，網路技術就像是水一樣，逐漸變成每個產業的必需，和不同產業揉合在一起又總是能展現出獨特的樣貌。這也是我進來新芽後，對於網路科技愈來愈著迷的原因。</p>

            <p>最後也不忘工商一下：在新芽實習的福利真的是 A+++ 等級，吃不完的零食、免費按摩、健身房補助……滿足你的各類需求，讓上班也是一件很快樂的事！如果你也想要親自感受這麼棒的實習氛圍，趕緊投遞履歷加入我們吧！</p>
        `,
    },
    {
        name: "JIMMY",
        position: "Marketing",
        img: JimmyPhoto,
        photo: Jimmy,
        article: `
            <p>加入一間年輕的公司，與 Mentor 討論發想、與產品一同進步，讓創意落實、讓想法被看見，是我對實習的憧憬。在新芽的日子裡，我每天都很慶幸自己當初有投出第二次履歷（第一次落榜拉～），每天也都有很多活動、很多夥伴、很多零食、很多工作（咦）的陪伴，超充實的。</p>

            <p>啊！我是第八屆蛋糕馬克停實習生 我叫 Jimmy ><</p>

            <p>這不是我的第一次實習，卻是最捨不得離開的一次。一切雖然是從遠距開始，但距離卻不影響 Mentor 從螢幕後方傳來的熱情以及滿滿的經驗。作為新芽實習生，每天都能遇到不同領域的高手，知識、星座、笑話、垃圾話...一堆新事物充滿我的工作日常，好愛！</p>

            <p>作為行銷實習生，我接觸到更多品牌端行銷的領域。包括實際撰寫文案、經營粉專/部落格、分析數據、操作 SEO ，另外還能培養綜合實力，像是每月提報、參加展覽、跨部門溝通、洞察會員使用流程...等，這些都讓我這個準新鮮人，有更多探索未來的機會，過程中 Mentor 都會手把手教學，給予建議同時鼓勵，每月 1 on 1 也會根據實習生想精進的領域，調整工作內容，飛快成長完全是新芽實習生的標配。</p>

            <p>所以，對新創、科技、行銷領域有興趣的你，快投履歷8～新芽的好，天知地知我知，你也要知</p>
        `,
    },
    {
        name: "BONNIE",
        position: "UI/UX Design",
        img: BonniePhoto,
        photo: Bonnie,
        article: `
            <p>Hi! 我是 UI/UX Design Intern Bonnie</p>

            <p>一開始投履歷的時候很擔心沒人願意收高年級實習生，好慶幸新芽的實習並無身份或年齡的限制，讓沒有相關經驗的我能有機會接觸各領域的產品專案。</p>

            <p>實習期間我主要負責支援專案設計，透過實作學習許多用戶體驗的相關知識，並且更熟悉軟體的使用，提高設計的效率。過程遇到任何困難時都能隨時提問，Mentor 與 PM 都非常樂意給予協助，很喜歡每次會議時與大家經驗分享、相互交流的氛圍。</p>

            <p>雖然因為疫情的關係大部分的時間都是 Remote，但透過 Hangouts 依然能與團隊順利協作，累積實戰經驗的同時也能顧健康、保平安。</p>

            <p>若你對 UI/UX 設計或網路科技產業有興趣，歡迎一起加入成為新芽的一份子：）</p>
        `,
    },
    {
        name: "CECILIA",
        position: "Business Development",
        img: CeciliaPhoto,
        photo: Cecilia,
        article: `
            <p>Hello 我是 Cecilia Wu，因為太難唸了所以可以叫我宜臻xd</p>

            <p>（有申請新芽實習或其他求職問題，可以停下焦慮的腳步，上 Linkedin 搜尋 Cecilia Wu 或來信 chopin.0099@gmail.com，這邊都可以小小的分享解答唷）</p>

            <p>在唸碩士二年級的最後一學年，終於在歷經兩個月的等待後，收到來自新芽的面試通知（正職們都太忙碌惹沒空面試哈哈），也幸運的進入到 SurveyCake 這個事業部，開始我的 BD 探索之旅！</p>

            <p>無論是主導跟客戶的會議、溝通產品與需求，或者在內部與 BD 夥伴提出各種流程優化的想法、爭取新專案的機會，又或者跟 PM 溝通，把難搞客戶的問題用自己的消化產出答案，都是非常有成就感的事 (〃∀〃)</p>

            <p>而作為這裡的實習生，一定要把握的有三件事：認識優秀友善的夥伴、主動積極的自我發揮、以及...享受超讚的員工福利xd</p>
            
            <p>首先，在新芽的人們，無論是正職或者實習生，通常都是熱愛挑戰與探索，也很願意分享及負責的夥伴，無論是跨部門溝通請教、提出新的計劃想實現、期待有人一起打球爬山、或失戀尋求安慰（？）都可以遇到合適的朋朋豐富工作跟生活！大愛 BD Team 尤其 Demi ，是王牌銷售員兼最棒的 Mentor &#12290;&#58;&#46;&#65439;&#12541;&#40;&#42;&#180;&#8704;&#96;&#41;&#65417;&#65439;&#46;&#58;&#12290;</p>
            
            <p>而在這樣一個開放自由的環境下，最重要的是當自己的 Project Manager，以終為始安排自己實習階段的目標與任務，雖然一開始一定會對能夠為公司跟團隊貢獻什麼感到迷惘，但過程中只要願意把想法分享、請教前輩，都會是豐富美好的收穫 &#32;&#180;&#45;&#969;&#45;&#41;&#98;</p>
            
            <p>最後，不免俗的要說，員工福利真的很讚，除了辦公室就讓自己以為在前景看好的外商公司，享受著星巴克咖啡跟專業按摩，還有零食、運動補助跟社團，只要好好的利用，就可以成為古羅馬全人（？），變得更加專業自信，也可以驕傲地說，我是從新芽畢業的實習生 ヽ(✿ﾟ▽ﾟ)ノ</p>
        `,
    },
    {
        name: "JENNIE",
        position: "Business Development",
        img: JenniePhoto,
        photo: Jennie,
        article: `
            <p>Hi, 我是 BD intern Jennie!</p>

            <p>還記得當初收到 Offer 時既興奮又緊張，一方面因能加入從大二開始即嚮往的公司而開心；另一方面也思考著已有新創實習經驗的我，能否在新芽創造更陡峭的學習曲線？</p>

            <p>而在結束了將近十個月的實習旅程後，我可以很肯定地說：加入新芽是我大學做過最棒的決定之一！</p>

            <p>首先，如同 CEO Alex 所說：在這裡，你就是 25sprout。在實習過程中，我看著和主管一起籌備的計畫實際落地、嘗試代表新芽和外部夥伴提案合作、在 BD Team 成員面前分享自己對於產品未來發展的看法等。在加入新芽前，我未曾想像過自己的聲音能被公司聽見且如此重視，而我也真切地體會到自己的貢獻確實能幫助公司的推進。</p>

            <p>除了重視 Intern 的想法、給予充足發揮空間外，公司也非常關注 Intern 的個人成長。主管經常詢問我還有沒有想嘗試的工作內容，並積極為我創造展現能力的舞台。舉例而言，我曾提過想練習數據分析，主管隨後就幫我爭取到了分析跨部門數據的機會，甚至讓我在公司週會分享我的分析成果。透過主管在旁指導和輔助，讓我在新芽的工作內容就像是客製化的學習計畫，也感受到自己的快速進步。</p>
            
            <p>除上面提到的兩點，新芽還有很多很棒的地方，例如舒適的工作環境和氛圍、溫暖有趣的同事和 Intern 朋友們等。這一路上獲得太多、多得難以一一細數，只好套句前人的話作總結：有機會加入新芽，真的是很幸福的事啊！</p>
        `,
    },
    {
        name: "MILEY",
        position: "Product Management",
        img: MileyPhoto,
        photo: Miley,
        article: `
            <p>Hi 我是 SurveyCake 的 PM 實習生 Miley～</p>

            <p>回想起進來新芽實習的這段神奇旅程，感到十分幸運又感謝！</p>

            <p>剛進來新芽的時候因為疫情而遠距上工，在不熟悉公司和工作流程的狀況下其實有些不安，還好有熱情溫暖的同事們帶我快速地上手與融入團隊，適時的垃圾話讓遠距交流不是問題，這樣的遠距經驗也讓我學習到如何用更精準的文字在不同的情境下與大家溝通，恢復實體後像見網友一樣的相認過程 (?) 也為這段實習經歷增添了一些特殊的樂趣 (｡◕∀◕｡)</p>

            <p>而在實習的過程中，從競品分析、使用者研究、易用性測試到產品測試、功能優化、新功能規劃，除了可以循序漸進地參與產品功能研究與開發的流程，也能透過參加開發會議、市場處會議等，藉由與不同部門的溝通，更瞭解產品的不同面向。</p>

            <p>在這裡，能夠體驗到充滿活力的工作氛圍，又能有充滿學習點的實戰經驗，如果你也在找尋更好的自己的話，加入新芽將會是一個很棒的選擇！</p>
        `,
    },
    {
        name: "CHING-YA",
        position: "Product Management",
        img: ChingYaPhoto,
        photo: ChingYa,
        article: `
            <p>很幸運能在新芽擔任 SurveyCake Product Management Intern，在新芽實習的日子裡，每天會遇到不同的挑戰，我們的任務是協助正職進行產品測試，確保交付給使用者的產品能順利運作。我們也會參與產品功能的設計，在這階段可以完整地體驗一個產品從規劃到開發的過程，我們會運用各種研究方法找出問題，和設計師、開發者一起發揮創意，發想出解決問題的方法，讓 SurveyCake 變得更好。除此之外我們也會學習如何撰寫清晰易懂的產品需求文件、參與跨部門的溝通與協作、嘗試理解產品開發技術的基礎概念 ... 等。真的是時刻都充滿挑戰。</p>

            <p>雖然實習中充滿挑戰但也不要擔心，新芽是一個新手友善的環境，在這裡的每個人都身懷絕技，不論你遇到什麼樣的困難，或是想學習哪一方面的知識，只要不害怕問問題、勇敢開口詢問，各路大神都很願意幫助你解答疑惑，在這裡能學習的知識和體驗的技能非常多元，能和新芽的大家一起交流、學習，真的是非常難能可貴的經驗。</p>
        `,
    },
]


// WEBPACK FOOTER //
// ./src/models/Sprouters2021.js